import api from 'api'

const FETCH_REQUEST = 'realhub/brandhub/helpDesk/publicationDeadlines/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/brandhub/helpDesk/publicationDeadlines/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/brandhub/helpDesk/publicationDeadlines/FETCH_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadPublicationDeadlines(options = {}){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    const promise = api('/admin/brandhub/publication_deadlines.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) return Promise.reject(json)

        // Set Result
        const payload = {}
        payload.result = json

        dispatch(fetchSuccess(payload))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { result, type, errors } = action

  switch (type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result: result || state.result,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors,
      })
    default:
      return state
  }
}
